import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 页面顶部进度条
// 样式设置：@/assets/css/global-base.scss
// 使用文档：http://192.168.10.99:5000/common-library

NProgress.configure({
    easing: "ease", // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载icon
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3, // 更改启用时使用的最小百分比
    parent: "body", // 制定容器
});

// 开始加载进度条
const nprogressStart = () => {
    NProgress.start();
};

// 结束进度条加载
const nprogressClose = () => {
    NProgress.done();
};

//! 通过如下方式直接导出函数，这样在全局自动按需引入后，就可以直接进行调用
export { nprogressStart, nprogressClose };
